<template>
    <div class="content-box">
         <div class="content">
             <div class="title-box">
                 <div class="title">
                     <div class="title-text">合作模式</div>
                     <div class="title-e">COOPERATION MODEL</div>
                     <div class="title-line"></div>
                 </div>
                 <div class="end-rukou">
                 </div>
             </div>
             <div class="describe">
                 平台可为充电大客户提供多种合作模式，客户可根据自身情况选择适合自己的最优合作模式。
             </div>
             <div class="describe-characteristic2 mt">
                 <div class="describe-characteristic-item">
                     <div class="item-img img41"></div>
                     <div class="item-text">充值返利</div>
                 </div>
                 <div class="describe-characteristic-item">
                     <div class="item-img img42"></div>
                     <div class="item-text">消费返利</div>
                 </div>
                 <div class="describe-characteristic-item">
                     <div class="item-img img43"></div>
                     <div class="item-text">协议电价</div>
                 </div>
             </div>
         </div>
    </div>

</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {},
}
</script>
<style src="./k_public.less" lang="less" scoped></style>
<!--<style lang="less" scoped>-->
    <!--.content-box{-->
        <!--width: 100%;-->
        <!--margin: 0px auto;-->
        <!--height: 100%;-->
        <!--background-color: #fff;-->
        <!--font-family:PingFangSC-Regular,PingFang SC;-->
        <!--.content{-->
            <!--width: 1200px;-->
            <!--height: 600px;-->
            <!--margin: 0px auto;-->
            <!--padding:20px;-->
            <!--position: relative;-->
            <!--.title-box{-->
                <!--display: flex;-->
                <!--justify-content: space-between;-->
                <!--font-size: 20px;-->
                <!--width: 1000px;-->
                <!--margin: 2% auto;-->
                <!--height: 66px;-->
                <!--text-align: left;-->
                <!--.title-text {-->
                    <!--color: #05123E;-->
                    <!--font-size: 30px;-->
                    <!--font-weight: 500;-->
                <!--}-->
                <!--.title-e {-->
                    <!--font-size: 10px;-->
                    <!--color: #6684D0;-->
                    <!--line-height: 30px;-->
                    <!--letter-spacing: 1px;-->
                <!--}-->
                <!--.title-line {-->
                    <!--background: linear-gradient(90deg,  #099AFF, #3AFEFE);-->
                    <!--height: 2px;-->
                    <!--width: 30px;-->
                    <!--margin: 0 auto;-->
                    <!--border-radius: 1px;-->
                    <!--margin-left: 0;-->
                <!--}-->
                <!--.end-rukou{-->
                    <!--font-size: 14px;-->
                    <!--color: #19C1E7;-->
                    <!--text-align: right;-->
                    <!--line-height: 66px;-->
                    <!--.icon-img{-->
                        <!--background-image: url('./../../../assets/icon_next 2@2x.png');-->
                        <!--display: inline-block;-->
                        <!--width: 24px;-->
                        <!--height: 24px;-->
                        <!--background-repeat: no-repeat;-->
                        <!--background-size: 24px 24px;-->
                        <!--margin-bottom: -6px;-->
                    <!--}-->
                <!--}-->
            <!--}-->
            <!--.describe{-->
                <!--width: 1000px;-->
                <!--margin: 0 auto;-->
                <!--text-align: left;-->
                <!--color: #526BAB;-->
                <!--font-size: 16px;-->
                <!--line-height: 30px;-->
            <!--}-->
            <!--.describe-characteristic{-->
                <!--width: 80%;-->
                <!--margin: 10px auto;-->
                <!--text-align: left;-->
                <!--color: #1A3068;-->
                <!--font-size: 14px;-->
                <!--line-height: 28px;-->
                <!--display: flex;-->
                <!--justify-content: center;-->
                <!--flex-flow: row;-->
                <!--.describe-characteristic-item{-->
                    <!--width: 160px;-->
                    <!--height:160px;-->
                    <!--background-color: #fff;-->
                    <!--box-shadow: 0px 6px 20px 0px rgba(0,0,0,0.05);-->
                    <!--margin: 0 50px;-->
                    <!--padding: 40px 20px;-->
                    <!--border-radius:10px;-->
                    <!--.item-img{-->
                        <!--width: 100px;-->
                        <!--height:100px;-->
                        <!--background-repeat: no-repeat;-->
                        <!--background-size: 100%;-->
                        <!--margin: 0 auto;-->
                    <!--}-->
                    <!--.img1{-->
                        <!--background-image: url('./../../../assets/c.png');-->
                    <!--}-->
                    <!--.img2{-->
                        <!--background-image: url('./../../../assets/v.png');-->
                    <!--}-->
                    <!--.img3{-->
                        <!--background-image: url('./../../../assets/h.png');-->
                    <!--}-->

                    <!--.item-text{-->
                        <!--text-align: center;-->
                        <!--font-size:16px;-->
                        <!--font-family:PingFangSC-Regular,PingFang SC;-->
                        <!--font-weight:400;-->
                        <!--color:rgba(26,48,104,1);-->
                        <!--line-height:50px;-->
                    <!--}-->
                <!--}-->
            <!--}-->
            <!--.data-describe{-->
                <!--width:1000px;-->
                <!--margin: 30px auto;-->
                <!--display: flex;-->
                <!--.data-box{-->
                    <!--width: 170px;-->
                    <!--height:120px;-->
                    <!--padding:10px;-->
                    <!--.data-num{-->
                        <!--color: #19C1E7;-->
                        <!--font-size: 21px;-->
                    <!--}-->
                    <!--.data-synopsis{-->
                        <!--font-size: 12px;-->
                        <!--line-height: 10px;-->
                        <!--font-family:PingFangSC-Regular,PingFang SC;-->
                        <!--font-weight:400;-->
                        <!--color:rgba(26,48,104,1);-->
                    <!--}-->
                <!--}-->
                <!--.data-line{-->
                    <!--min-width: 1px;-->
                    <!--height: 50px;-->
                    <!--background-color: #E6E9F3;-->
                    <!--margin-top: 20px;-->
                <!--}-->

            <!--}-->
            <!--.img-describe{-->
                <!--height: 350px;-->
                <!--width: 376px;-->
                <!--background-image: url('./../../../assets/cwdz.gif');-->
                <!--background-repeat: no-repeat;-->
                <!--background-size: 80%;-->
                <!--position: absolute;-->
                <!--bottom: 80px;-->
                <!--right: 60px;-->
            <!--}-->
        <!--}-->
    <!--}-->

    <!--@media screen and (max-width: 1100px) {-->
        <!--.img-describe{-->
            <!--background-size: 60%!important;-->
            <!--right: -40px!important;-->
        <!--}-->
    <!--}-->
    <!--@media screen and (max-width: 1000px) {-->
        <!--.img-describe{-->
            <!--background-size:45%!important;-->
            <!--height: 260px;-->
            <!--width: 264px;-->
            <!--position: absolute;-->
            <!--bottom: 60px!important;-->
            <!--right:-100px!important;-->
        <!--}-->
    <!--}-->
    <!--@media screen and (max-width: 800px) {-->
        <!--.img-describe{-->
            <!--display: none;-->
        <!--}-->
    <!--}-->








<!--</style>-->